import HelpDialog from './HelpDialog';

export default HelpDialog;



// WEBPACK FOOTER //
// ./src/features/auth/helpDialog/index.ts